import * as React from 'react';

import classNames from 'classnames';

import {Stack} from 'shells/layout/stack/stack';
import type {Tag} from 'shells/tags-editor/tags-editor';

import type {GetLead_lead as Lead} from 'nutshell-graphql-types';

import {useGetSessionUser} from '../../core/use-get-session-user';

import {useLeadUpdateRefetch} from '../use-lead-update-refetch';

import {HeaderActionBar} from './header-action-bar';
import {HeaderStats} from './header-stats';
import {StageCarouselWrapper} from './stage-carousel-wrapper';

type Props = {
    lead: Lead;
    onUpdateLeadName: (arg1: string) => Promise<any>;
    refetchLead: () => Promise<any>;
    onUpdateTags: (arg1: Tag[]) => void;
    fetchTags: (arg1: string) => Promise<any>;
    onUpdateLeadConfidence: (arg1: number) => void;
    onUpdateLeadCreatedDate: (arg1?: Date | null | undefined) => void;
    onUpdateLeadDueDate: (arg1?: Date | null | undefined) => void;
    onUpdateLeadClosedDate: (arg1?: Date | null | undefined) => void;
};

export function Header(props: Props) {
    const {user} = useGetSessionUser();

    useLeadUpdateRefetch(props.lead.id);

    return (
        <div
            className={classNames('px-16 py-12 background-white border-box', {
                'pb-16': NutClientConfig.hasCoreEntityFullHeightSidebarFF,
            })}
        >
            <Stack spacing={16}>
                <HeaderActionBar
                    lead={props.lead}
                    user={user}
                    onUpdateLeadName={props.onUpdateLeadName}
                    onUpdateTags={props.onUpdateTags}
                    fetchTags={props.fetchTags}
                />
                {!NutClientConfig.hasCoreEntityFullHeightSidebarFF && (
                    <HeaderStats
                        lead={props.lead}
                        onUpdateLeadConfidence={props.onUpdateLeadConfidence}
                        onUpdateLeadCreatedDate={props.onUpdateLeadCreatedDate}
                        onUpdateLeadDueDate={props.onUpdateLeadDueDate}
                        onUpdateLeadClosedDate={props.onUpdateLeadClosedDate}
                    />
                )}
                <StageCarouselWrapper
                    leadId={props.lead.id}
                    isHot={props.lead.isHot}
                    pipelineName={props.lead.stageset && props.lead.stageset.name}
                    pipelineId={props.lead.stageset && props.lead.stageset.id}
                    stages={props.lead.stages.edges}
                    refetchLead={props.refetchLead}
                    leadStatus={props.lead.status}
                />
            </Stack>
        </div>
    );
}
